var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2906 16.9954C31.228 16.9 17.2344 30.5284 17.1392 47.5655L17.1392 47.5729C16.9487 64.6229 30.6655 78.6216 47.7093 78.7168L47.7168 78.7169C64.7668 78.9074 78.7654 65.1907 78.8607 48.1468L78.8607 48.1393C79.0512 31.0893 65.3345 17.0906 48.2906 16.9954ZM14.4674 47.5468C14.573 29.0103 29.7942 14.2201 48.3055 14.3235C66.8359 14.4271 81.7376 29.642 81.5325 48.1658C81.4267 66.6942 66.2127 81.5938 47.6903 81.3886C29.162 81.2829 14.2625 66.069 14.4674 47.5468Z",
    fill: "#9BE7C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8069 38.4988C62.3298 39.0193 62.3318 39.8652 61.8113 40.3881L45.6796 56.5955C44.3474 57.9339 42.2873 57.9408 40.9477 56.6162L34.2262 50.3748C33.6855 49.8727 33.6542 49.0274 34.1563 48.4868C34.6583 47.9461 35.5036 47.9148 36.0443 48.4168L42.7829 54.6741C42.7957 54.6861 42.8083 54.6982 42.8207 54.7107C43.1153 55.0066 43.4913 55.0066 43.7858 54.7107L59.9176 38.5032C60.4381 37.9803 61.2839 37.9783 61.8069 38.4988Z",
    fill: "#9BE7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a4bc63c75b483d2176a9b53755a111d1.svg";
export { ForwardRef as ReactComponent };